<template>
  <div>
    <div class="d-flex justify-space-between align-center mb-2">
      <h4 class="mb-0">Seleione o evento</h4>
      <v-btn @click="fetchParties" icon :loading="loading" :disabled="loading">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </div>
    <v-alert v-if="error" type="error" class="mb-4">
      {{ error }}
    </v-alert>
    <v-row v-else>
      <template v-if="loading">
        <v-col cols="12" sm="6" md="6" lg="4" v-for="n in 6" :key="n">
          <v-card outlined rounded="lg">
            <v-skeleton-loader
              type="card"
              width="100%"
              :loading="loading"
            ></v-skeleton-loader>
          </v-card>
        </v-col>
      </template>
      <template v-else>
        <v-col
          v-for="party in parties"
          :key="party.id"
          cols="12"
          sm="6"
          md="6"
          lg="4"
        >
          <PartyItem
            :party="party"
            :custom-click-event="selectParty"
            outlined
          />
        </v-col>
      </template>
    </v-row>
  </div>
</template>
<script>
import VIRTUAL_POS from "@/services/staff/virtualPos";
import PartyItem from "../../shop/PartyItem.vue";

export default {
  name: "PartySelect",
  components: {
    PartyItem,
  },
  props: {
    token: {
      type: Object,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      parties: [],
      loading: false,
      error: null,
    };
  },
  methods: {
    selectParty(party) {
      console.log("Selected party:", party);
      this.$emit("select-party", party);
      this.$emit("next");
    },
    async fetchParties() {
      try {
        this.loading = true;
        this.error = null;
        const response = await VIRTUAL_POS.getAllParties(this.token);
        this.parties = response.parties;
      } catch (e) {
        this.error = e.message || "Erro ao carregar eventos";
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.fetchParties();
  },
};
</script>
